"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kefir = require("kefir");

var events = function events(element) {
  return function (name) {
    var stream = element.flatMapLatest(function (e) {
      return _kefir.Kefir.fromEvents(e, name);
    });

    stream.preventDefault = function () {
      return stream.observe(function (e) {
        return e.preventDefault();
      });
    };

    return stream;
  };
};

exports.default = events;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@standard-library/unknot/build/events.js
// module id = 166
// module chunks = 0